<template>
  <EditorUiConfigPanel :expanded="expanded" @toggle="togglePanelVisibility">
    <template #header>
      <p class="mb-0 mr-2 text-xs font-medium">Slide configuration</p>
    </template>

    <template #default>
      <div class="space-y-4 py-3.5">
        <EditorDeckSlidesThreeDDrillDataConfigControl>
          <p class="text-sm">All Surface Markers</p>
        </EditorDeckSlidesThreeDDrillDataConfigControl>

        <EditorDeckSlidesThreeDDrillDataConfigControl>
          <p class="text-sm">All Drill Traces</p>
        </EditorDeckSlidesThreeDDrillDataConfigControl>
      </div>
    </template>
  </EditorUiConfigPanel>
</template>

<script lang="ts" setup>
defineProps({
  expanded: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['toggle'])

function togglePanelVisibility() {
  emit('toggle')
}
</script>
